import React, { PureComponent } from 'react';
import EXPLCTRL from './EXPLCTRL';

export default class DESKTOP extends PureComponent {
    constructor(props) {
        super(props);

        let initialPath = "C:\\WINDOWS\\DESKTOP";

        this.state = {};
        this.state.currentPath = initialPath;
        this.state.currentInfo = window.WINAPI.GetFileInfo(this.state.currentPath);
        this.state.currentDirectory = window.WINAPI.FindFile(this.state.currentPath);

        this.activeWindowHandler = window.WINAPI.SetWinEventHook("dismiss", () => {
            if (this.explctrl) {
                this.explctrl.onFocusLost();
            }
        });
    }

    componentWillUnmount() {
        window.WINAPI.UnhookWinEvent("dismiss", this.activeWindowHandler);
    }

    render() {
        return <div className="desktop">
            <EXPLCTRL path={this.state.currentPath}
                directory={this.state.currentDirectory}
                showChrome={false}
                stackVertically={true}
                ref={(c) => {this.explctrl = c}} />
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/walleris/EXPLORE/DESKTOP.js